import React from "react";
import { GlobalOutlined, MobileOutlined } from "@ant-design/icons";

const FINANCE_APP_URL = "https://api.simolapps.ru/v1/go/fin";
const FINANCE_WEB_URL = "https://finansi.simolapps.ru/";

export default function FinanceAccessCard() {
  return (
    <aside className="finance-access-card" aria-label="Приложение Финансы">
      <img
        className="finance-access-card__icon"
        src="/downloads/apps/finansi-android/icon.png"
        alt=""
        width="42"
        height="42"
      />
      <div className="finance-access-card__content">
        <strong>Финансы</strong>
        <span>Учёт денег и малого бизнеса</span>
      </div>
      <div className="finance-access-card__actions" aria-label="Выберите версию Финансов">
        <a href={FINANCE_APP_URL} target="_blank" rel="noreferrer">
          <MobileOutlined aria-hidden="true" />
          <span>Приложение</span>
        </a>
        <a href={FINANCE_WEB_URL} target="_blank" rel="noreferrer">
          <GlobalOutlined aria-hidden="true" />
          <span>Web</span>
        </a>
      </div>
    </aside>
  );
}
